export default __webpack_public_path__ + "static/N0085-7239ba8b2c6d83fe26bf6acc4fa4da5c.png";